import { Controller } from "@hotwired/stimulus"
import { roundPrice } from "../../src/f_numbers"

// Podsumowanie pozycji zamówienia — sumuje razem netto, VAT, brutto, rabat
// Nasłuchuje na zmiany w polach pozycji (event bubbling)
export default class extends Controller {
  static targets = ["summaryNet", "summaryTax", "summaryGross", "summaryDiscount", "discountRow"]

  static values = {
    precision: { type: Number, default: 2 },
  }

  recalculate() {
    // setTimeout aby poczekać aż nested-form ukryje/usunie pozycję
    setTimeout(() => this._doRecalculate(), 0)
  }

  _doRecalculate() {
    const p = this.precisionValue
    let totalNet = 0
    let totalGross = 0
    let totalDiscount = 0

    // znajdź wszystkie widoczne pozycje (nie usunięte)
    this.element.querySelectorAll("[data-nested-form-target='fields']").forEach(row => {
      if (row.style.display === "none") return
      const destroy = row.querySelector("input[name*='_destroy']")
      if (destroy && destroy.value === "1") return

      const netEl = row.querySelector("[data-commerce--product-select-target='totalNet']")
      const grossEl = row.querySelector("[data-commerce--product-select-target='totalGross']")
      const qtyEl = row.querySelector("[data-commerce--product-select-target='quantity']")
      const amountNetEl = row.querySelector("[data-commerce--product-select-target='amountNet']")
      const discountPctEl = row.querySelector("[data-commerce--product-select-target='discountPercent']")

      if (netEl) totalNet += this._parse(netEl.value)
      if (grossEl) totalGross += this._parse(grossEl.value)

      // Rabat netto pozycji = amount_net * qty * (percent/100)
      if (discountPctEl && amountNetEl && qtyEl) {
        const pct = this._parse(discountPctEl.value)
        if (pct > 0) {
          const baseNet = this._parse(amountNetEl.value) * this._parse(qtyEl.value)
          totalDiscount += baseNet * (pct / 100)
        }
      }
    })

    const tax = roundPrice(totalGross - totalNet, p)
    totalNet = roundPrice(totalNet, p)
    totalGross = roundPrice(totalGross, p)
    totalDiscount = roundPrice(totalDiscount, p)

    if (this.hasSummaryNetTarget) this.summaryNetTarget.textContent = this._fmt(totalNet, p)
    if (this.hasSummaryTaxTarget) this.summaryTaxTarget.textContent = this._fmt(tax, p)
    if (this.hasSummaryGrossTarget) this.summaryGrossTarget.textContent = this._fmt(totalGross, p)
    if (this.hasSummaryDiscountTarget) this.summaryDiscountTarget.textContent = this._fmt(totalDiscount, p)
    if (this.hasDiscountRowTarget) this.discountRowTarget.classList.toggle("hidden", totalDiscount <= 0)
  }

  _parse(val) {
    const v = parseFloat(String(val).replace(",", "."))
    return isNaN(v) ? 0 : v
  }

  _fmt(val, precision) {
    return val.toFixed(precision).replace(".", ",")
  }
}
